/** @jsxImportSource @emotion/react */
import { useTheme } from '@emotion/react';
import React, { HTMLInputTypeAttribute } from 'react';
import { onlyNumber } from 'shared/utils/regx/only-number';
import UDFormInput from 'ud-form/components/input';
import UDText from 'ud-ui/components/text';
import { DivProps } from 'typings';
import { InputCss } from './styles';

interface IProps extends Omit<DivProps, 'onChange'> {
  name: string;
  text: string;
  type?: HTMLInputTypeAttribute;
  readonly: boolean;
}

function SizeItem(props: IProps) {
  const { name, type, readonly, ...rest } = props;
  const theme = useTheme();

  return (
    <div className={'flex flex-row items-center'} style={{ gap: '10px' }} {...rest}>
      <UDText type={'caption-1'} className={'text-Gray96'}>
        {props.text}
      </UDText>
      <UDFormInput readOnly={readonly} parser={onlyNumber} css={InputCss(theme)} name={name} type={type} />
    </div>
  );
}

export default SizeItem;
